<div class="toggleBox" [class]="{isToggle: isToggle}" (click)="toggle()">
  <div class="toggle" [class]="{isToggle: isToggle}"></div>
</div>
<span>{{label}}</span>